import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import messages from './messages';

function getResponseText(message, params) {
    switch (message) {
    case 'EMAIL_USED_BY_ANOTHER_USER': return messages.emailUsedByAnotherUser.defaultMessage(params.email);
    default: return message;
    }
}

export function* getTeacherByUserProfileId({ productId, userProfileId }) {
    const payload = yield call(api.getTeacherByUserProfileId, productId, userProfileId);
    if (payload.status === 200) {
        payload.adminPassword = '';
        payload.newPassword = '';
        payload.confirmationPassword = '';
        payload.isResetTeacherpassword = false;
        yield put(actions.getTeacherSuccess(payload));
    } else {
        yield put(actions.getTeacherFailure());
    }
}

export function* editTeacherInformation({ teacher, context }) {
    const response = yield call(api.editTeacher, teacher);
    if (response.status === 200) {
        yield put(actions.editTeacherSuccess(context));
    } else if (response.status === 400 || response.status === 409) {
        const message = getResponseText(response.message, { email: teacher.emailAddress });
        yield put(actions.editTeacherFailure(false, message));
    } else {
        yield put(actions.editTeacherFailure(true, ''));
    }
}

export function* downloadClassroomStudentsSignInCards({ classroomId, productId, downloadingClassroomIds, SignInCardPageSizeType }) {
    const response = yield call(api.downloadClassroomStudentsSignInCards, { productId, classroomId, SignInCardPageSizeType });
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.printClassroomStudentsSignInCardSuccess(classroomId, downloadUrl, downloadingClassroomIds));
    } else {
        yield put(actions.printClassroomStudentsSignInCardFailure(classroomId, downloadingClassroomIds));
    }
}

export function* getTeacherByUserProfileIdSaga() {
    yield takeLatest(actions.GET_TEACHER_REQUEST, getTeacherByUserProfileId);
}

export function* unassignTeachersByClassId({ userProfileId, classId }) {
    const teacherDetail = {
        classroomId: classId,
        teachersProfileIdToUnassign: [userProfileId]
    };
    const response = yield call(api.unAssignTeachers, teacherDetail);
    if (response.status === 200) {
        yield put(actions.unassignTeachersByClassIdSuccess());
    } else {
        yield put(actions.unassignTeachersByClassIdFailure());
    }
}

export function* unassignTeachersByClassIdSaga() {
    yield takeLatest(actions.UNASSIGN_TEACHERS_USING_CLASSID_REQUEST, unassignTeachersByClassId);
}

export function* editTeacherSaga() {
    yield takeLatest(actions.EDIT_TEACHER_REQUEST, editTeacherInformation);
}

export function* downloadClassroomStudentsSignInCardSaga() {
    yield takeEvery(actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST, downloadClassroomStudentsSignInCards);
}

export function* sendPasswordLink(data) {
    const request = { productId: data.productId, userProfileId: data.userProfileId };
    const payload = yield call(api.sendTeacherPassword, request);
    if (payload.status === 200) {
        yield put(actions.sendPasswordLinkSuccess(payload));
    } else {
        yield put(actions.sendPasswordLinkFailure(payload.message));
    }
}

export function* sendPasswordLinkSaga() {
    yield takeEvery(actions.SEND_PASSWORD_LINK_REQUEST, sendPasswordLink);
}


export function* sendEmailVerificationLink(data) {
    const request = { userProfileId: data.userProfileId };
    const payload = yield call(api.sendVerificationEmail, request);
    if (payload.status === 200) {
        yield put(actions.sendVerificationEmailLinkSuccess(payload));
    } else {
        yield put(actions.sendVerificationEmailLinkFailure(payload.message));
    }
}

export function* sendEmailVerificationLinkSaga() {
    yield takeEvery(actions.SEND_VERIFICATION_EMAIL_LINK_REQUEST, sendEmailVerificationLink);
}



// WEBPACK FOOTER //
// ./app/containers/edit-teacher/saga.js